module.exports = __webpack_public_path__ + "static/img/join_4.38fe4ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_4.jpg
// module id = xEsQ
// module chunks = 1